/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import { Container, Row, Col } from 'react-bootstrap';
import ScrollSpy from 'react-ui-scrollspy';
import { Link } from 'react-router-dom';
import Layouts from '../../../layouts/Layouts';
import {
  DocLocationCard,
  DoctorReviewCard,
  SimpleCard
} from '../../../Components/Card';
import {
  HeadingDesc,
  HeadingDescSmall,
  HeadingDescVsmall,
  HeadingWithSpaceLarge,
  SectionHeadingLarge,
  SectionInnerHeading
} from '../../../Components/Headings';
import { RankTag, SimpleTag } from '../../../Components/tags';
import { RatingStars } from '../../../Components/rating';
import tagIcon from '../../../assets/images/svg/platinium-rank.svg';
import img from '../../../assets/images/png/article2.png';
import timeIcon from '../../../assets/images/png/clock-yellow.png';
import starIcon from '../../../assets/images/png/star-yellow.png';
import { SectionHeading } from '../../../Components/SectionHeading';
import { RightArrowWithBorder } from '../../../Components/icons';
import {
  AncerWithUnderlineSmall,
  SimpleAncerSmall
} from '../../../Components/button';
import LatestVideos from '../../../Components/latestVideos/LatestVideos';
import LatestArticles from '../../../Components/latestArticles/LatestArticles';
import AccordionComp from '../../../Components/accordionComp/AccordionComp';
import CustomSelect2 from '../../../Components/customSelect2/CustomSelect2';
import CustomCalender from '../../../Components/customCalender/CustomCalender';
import './doctorDetail.css';

const docInfos = [
  {
    docImg: img,
    docName: 'Prof. Dr. Nadia Khurshid Ahmed',
    speciality: 'Gynecologist, Obstetrician',
    education: 'M.B.B.S, F.C.P.S (Gynecology & Obstetrics), MRCOG',
    experience: '20 Years',
    waitTime: 'Under 15 Min',
    rank: 'platinum',
    rankIcon: tagIcon,
    rankColor: '#FFEDC9',
    waitTimeStatus: 'Patients waited less than 15 minutes',
    recomandationStatus: '100% of patients gave 5 stars',
    overAllRating: 5,
    locations: [
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'IN-PERSON APPOINTMENT'
      },
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'IN-PERSON APPOINTMENT'
      },
      {
        price: '1500',
        location: 'The Doctors Plaza (Clifton)',
        available: 'Available Wed, Apr 06',
        btnText: 'START VIDEO CONSULTATION'
      }
    ],
    reviews: [
      {
        name: 'Nargis G',
        time: 'Less than 6 months ago',
        status: 'In-Person',
        rating: 5,
        comment:
          'Staff was great, Zeke the assistant was amazing. Augustin the hygenist did a great job on my cleaning. Melissa and Jennifer made sure I understood my treatment plan.'
      },
      {
        name: 'Babar Rashid Khan',
        time: 'Less than 6 months ago',
        status: 'In-Person',
        rating: 5,
        comment:
          'Dr. Kharazi helped me through a series of traumatic moments in my life. He assisted me in stabilizing my mood and focused my energies and thoughts on the path to health and personal growth. I highly recommend Dr. Kharazi for all types of situations and patients. He has a firm grasp on the technical aspects of therapy, a strong intuition, and a humility and care that I found very endearing.'
      },
      {
        name: 'Muhammad Salman',
        time: '1 year ago',
        status: 'In-Person',
        rating: 5,
        comment:
          'I’ve seen a few therapists before Dr. Kharazi and my experiences were just so-so. But Dr. Kharazi changed all of that for me - he is the best therapist I’ve ever met with and I can’t say enough good things about him. He truly listens and approaches issues with a warm and curious demeanor. He is extremely approachable and makes a challenging thing like therapy very accessible. Dr. Kharazi helped me acknowledge difficult things about myself and come to terms with the things I feared. He’s simply the best, thanks doc!'
      },
      {
        name: 'Nargis G',
        time: 'Less than 6 months ago',
        status: 'In-Person',
        rating: 5,
        comment:
          'Staff was great, Zeke the assistant was amazing. Augustin the hygenist did a great job on my cleaning. Melissa and Jennifer made sure I understood my treatment plan.'
      },
      {
        name: 'Babar Rashid Khan',
        time: 'Less than 6 months ago',
        status: 'In-Person',
        rating: 5,
        comment:
          'Dr. Kharazi helped me through a series of traumatic moments in my life. He assisted me in stabilizing my mood and focused my energies and thoughts on the path to health and personal growth. I highly recommend Dr. Kharazi for all types of situations and patients. He has a firm grasp on the technical aspects of therapy, a strong intuition, and a humility and care that I found very endearing.'
      },
      {
        name: 'Muhammad Salman',
        time: '1 year ago',
        status: 'In-Person',
        rating: 5,
        comment:
          'I’ve seen a few therapists before Dr. Kharazi and my experiences were just so-so. But Dr. Kharazi changed all of that for me - he is the best therapist I’ve ever met with and I can’t say enough good things about him. He truly listens and approaches issues with a warm and curious demeanor. He is extremely approachable and makes a challenging thing like therapy very accessible. Dr. Kharazi helped me acknowledge difficult things about myself and come to terms with the things I feared. He’s simply the best, thanks doc!'
      }
    ],
    about:
      'Prof. Nadia Khurshid Ahmed is a Gynecologist and Obstetrician. She has a M.B.B.S, F.C.P.S. (Gynecology & Obstetrician) and M.C.P.S degree. Post fellowship experience is 19 years including seven years foreign experience. Prof. Nadia Khurshid is member and examiner of MCPS and FCPS exam. Moreover She is author of a gyne-obs MCQ book and Obstetrics in a Minute under Paramount publishers Karachi. Prof. Nadia Khurshid is also a member of Pakistan Medical and Dental Council (PMDC). She is also instructor of course under college of physician and surgeons. Prof. Nadia Khurshid Ahmed practices as a Gynecologist at Online Video Consultation and National Hospital & Medical Centre and charges 3000 and 2500 respectively.',
    educationList: [
      'MBBS from Rawalpindi Medical College, Pakistan',
      'FCPS (Dermatology) from College of Physicians & Surgeons Pakistan',
      'CAAAM from American Academy of Aesthetic Medicine'
    ],
    membershipList: [
      'Pakistan Medical Comission (PMC)',
      'College of Physicians and Surgeons Pakistan'
    ],
    servicesList: [
      'Antenatal Checkup',
      'aesarean Section / Gynecological Surgery',
      'Clinical Breast Examination (CBE)',
      'iagnostic Laparoscopy and Aesthetic',
      'Epidural Analgesia',
      'Gynaecological Tumors',
      'High Risk Pregnancy',
      'Infertility Treatment',
      'Polycystic Ovary Syndrome (PCOS)',
      'Post-menopausal Bleeding'
    ],
    waitTimeRating: 4,
    besideMannerRating: 5,
    reaviewStatus:
      'Your trust is our top concern, so providers can’t pay to alter or remove reviews. We also don’t publish reviews that contain any private patient health information.',
    reaviewStatusLink: '/',
    totalRevies: 24,
    faqs: [
      {
        heading:
          'What is the fee of Prof. Dr. Nadia Khurshid Ahmed & how do I pay?',
        desc: 'Prof. Dr. Nadia Khurshid Ahmed has the following degrees: M.B.B.S, F.C.P.S.',
        content: '(Gynecology & Obstetrician), M.C.P.S'
      },
      {
        heading:
          'Where does Prof. Dr. Nadia Khurshid Ahmed practice & what are the timings?',
        desc: 'Prof. Dr. Nadia Khurshid Ahmed has the following degrees: M.B.B.S, F.C.P.S.',
        content: '(Gynecology & Obstetrician), M.C.P.S'
      },
      {
        heading: 'What is the feedback of Prof. Dr. Nadia Khurshid Ahmed?',
        desc: 'Prof. Dr. Nadia Khurshid Ahmed has the following degrees: M.B.B.S, F.C.P.S.',
        content: '(Gynecology & Obstetrician), M.C.P.S'
      },
      {
        heading: 'What is the education of Prof. Dr. Nadia Khurshid Ahmed?',
        desc: 'Prof. Dr. Nadia Khurshid Ahmed has the following degrees: M.B.B.S, F.C.P.S.',
        content: '(Gynecology & Obstetrician), M.C.P.S'
      },
      {
        heading:
          'Where does Prof. Dr. Nadia Khurshid Ahmed practice & what are the timings?',
        desc: 'Prof. Dr. Nadia Khurshid Ahmed has the following degrees: M.B.B.S, F.C.P.S.',
        content: '(Gynecology & Obstetrician), M.C.P.S'
      },
      {
        heading: 'What is the feedback of Prof. Dr. Nadia Khurshid Ahmed?',
        desc: 'Prof. Dr. Nadia Khurshid Ahmed has the following degrees: M.B.B.S, F.C.P.S.',
        content: '(Gynecology & Obstetrician), M.C.P.S'
      },
      {
        heading: 'What is the education of Prof. Dr. Nadia Khurshid Ahmed?',
        desc: 'Prof. Dr. Nadia Khurshid Ahmed has the following degrees: M.B.B.S, F.C.P.S.',
        content: '(Gynecology & Obstetrician), M.C.P.S'
      }
    ]
  }
];

const selectClinic = [
  { label: 'Iqbal Clinic', value: 'iqbal-clinic' },
  { label: 'Babu Clinic', value: 'babu-clinic' }
];

const typeOfAppoinment = [
  { label: 'Video', value: 'video' },
  { label: 'Chat', value: 'chat' }
];

const reasonForConsultation = [
  { label: 'Regular Check up', value: 'regular check up' },
  { label: 'Monthly Check up', value: 'monthly check up' }
];

function DoctorDetail() {
  return (
    <Layouts>
      <section className="doctorDetail">
        <Container>
          <Row>
            <Col md={8}>
              <div className="leftBox">
                {docInfos.map((docInfo, index) => {
                  const {
                    docImg,
                    docName,
                    speciality,
                    education,
                    experience,
                    waitTime,
                    rankIcon,
                    rank,
                    rankColor,
                    waitTimeStatus,
                    locations,
                    overAllRating,
                    reviews,
                    about,
                    educationList,
                    membershipList,
                    servicesList,
                    waitTimeRating,
                    besideMannerRating,
                    reaviewStatus,
                    reaviewStatusLink,
                    totalRevies,
                    faqs
                  } = docInfo;
                  return (
                    <div>
                      <div className="docInfoCard" key={index}>
                        <SimpleCard>
                          <div className="imgBox">
                            <img src={docImg} alt="docImg" />
                          </div>
                          <div className="content">
                            <SectionInnerHeading text={docName} />
                            <HeadingDescSmall text={speciality} />
                            <HeadingDescSmall text={education} />
                            <div className="experiance">
                              <h5 className="heading_desc_small">
                                <b>Experience:</b> {experience} |
                                <b>Wait Time:</b>
                                {waitTime}
                              </h5>
                            </div>
                            <RankTag
                              icon={rankIcon}
                              bgColor={rankColor}
                              text={`${rank} DOCTOR`}
                            />
                          </div>
                        </SimpleCard>
                      </div>
                      <Row>
                        <Col md={6}>
                          <div className="statusCard">
                            <SimpleCard>
                              <div className="iconBox">
                                <img src={timeIcon} alt="timeIcon" />
                              </div>
                              <div className="content">
                                <HeadingDescSmall
                                  text={<b>Excellent wait time</b>}
                                />
                                <HeadingDescSmall text={waitTimeStatus} />
                              </div>
                            </SimpleCard>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="statusCard">
                            <SimpleCard>
                              <div className="iconBox">
                                <img src={starIcon} alt="starIcon" />
                              </div>
                              <div className="content">
                                <HeadingDescSmall
                                  text={<b>Highly recommended</b>}
                                />
                                <HeadingDescSmall text={waitTimeStatus} />
                              </div>
                            </SimpleCard>
                          </div>
                        </Col>
                        <Col md={12}>
                          <DocLocationCard locations={locations} />
                        </Col>
                        <Col md={3}>
                          <div className="overAllRating">
                            <HeadingDesc text={<b>Overall rating</b>} />
                            <SectionHeadingLarge text={`${overAllRating}.00`} />
                            <RatingStars newValue={5} />
                          </div>
                        </Col>
                        <Col md={9}>
                          <div className="comments">
                            <DoctorReviewCard data={reviews.slice(0, 2)} />
                          </div>
                        </Col>
                        <Col md={12}>
                          <div id="ContainerElementID" className="scrollSpyNav">
                            <a
                              className="scrollSpyLink"
                              href="#about"
                              data-to-scrollspy-id="about"
                            >
                              About
                            </a>
                            <a
                              className="scrollSpyLink"
                              href="#services"
                              data-to-scrollspy-id="services"
                            >
                              Services
                            </a>
                            <a
                              className="scrollSpyLink"
                              href="#other-info"
                              data-to-scrollspy-id="other-info"
                            >
                              Other Info
                            </a>
                            <a
                              className="scrollSpyLink"
                              href="#four"
                              data-to-scrollspy-id="four"
                            >
                              Reviews
                            </a>
                            <a
                              className="scrollSpyLink"
                              href="#faqs"
                              data-to-scrollspy-id="faqs"
                            >
                              FAQs
                            </a>
                          </div>
                          <ScrollSpy offsetTop={-100}>
                            <section id="about">
                              <div className="tabTitle">
                                <HeadingWithSpaceLarge text="ABOUT" />
                              </div>
                              <HeadingDescSmall text={about} />
                              <div>
                                <HeadingWithSpaceLarge
                                  text={
                                    <span className="t-black">EDUCATION</span>
                                  }
                                />
                                <ul className="customList">
                                  {educationList.map((list, index) => (
                                    <li key={index}>
                                      <HeadingDescSmall text={list} />
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div>
                                <HeadingWithSpaceLarge
                                  text={
                                    // eslint-disable-next-line prettier/prettier
                                        <span className="t-black">PROFESSIONAL MEMBERSHIPS</span>
                                  }
                                />
                                <ul className="customList">
                                  {membershipList.map((list, index) => (
                                    <li key={index}>
                                      <HeadingDescSmall text={list} />
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <hr />
                            </section>
                            <section id="services">
                              <div className="tabTitle">
                                <HeadingWithSpaceLarge text="SERVICES" />
                              </div>
                              <ul className="customList">
                                {servicesList.map((list, index) => (
                                  <li key={index}>
                                    <HeadingDescSmall text={list} />
                                  </li>
                                ))}
                              </ul>
                            </section>
                            <section id="other-info">
                              <SectionHeading
                                heading={
                                  <HeadingWithSpaceLarge text="LATEST ARTICLES" />
                                }
                                icon={<RightArrowWithBorder />}
                                link={
                                  <AncerWithUnderlineSmall text="view all" />
                                }
                              />
                              <LatestArticles />
                              <SectionHeading
                                heading={
                                  <HeadingWithSpaceLarge text="LATEST VIDEOS" />
                                }
                                icon={<RightArrowWithBorder />}
                                link={
                                  <AncerWithUnderlineSmall text="view all" />
                                }
                              />
                              <LatestVideos />
                              <hr />
                            </section>
                            <section id="four">
                              <div className="tabTitle">
                                <HeadingWithSpaceLarge text="REVIEWS" />
                                <HeadingDescSmall text="All reviews have been submitted by patients after seeing the provider." />
                              </div>
                              <div className="reviewStatus">
                                <SimpleTag>
                                  <h6 className="headingDescVsmall">
                                    <b>
                                      {reaviewStatus}
                                      <Link to={reaviewStatusLink}>
                                        Learn more here
                                      </Link>
                                    </b>
                                  </h6>
                                </SimpleTag>
                              </div>
                              <Row>
                                <Col md={4}>
                                  <div className="reviwBox">
                                    <HeadingDescSmall
                                      text={<b>Overall Rating</b>}
                                    />
                                    <div className="dFlex">
                                      <RatingStars newValue={overAllRating} />
                                      <HeadingDesc
                                        text={<b>{overAllRating}.00</b>}
                                      />
                                    </div>
                                  </div>
                                </Col>
                                <Col md={4}>
                                  <div className="reviwBox">
                                    <HeadingDescSmall text={<b>Wait Time</b>} />
                                    <div className="dFlex">
                                      <RatingStars newValue={overAllRating} />
                                      <HeadingDesc
                                        text={<b>{waitTimeRating}.00</b>}
                                      />
                                    </div>
                                  </div>
                                </Col>
                                <Col md={4}>
                                  <div className="reviwBox">
                                    <HeadingDescSmall
                                      text={<b>Bedside Manner</b>}
                                    />
                                    <div className="dFlex">
                                      <RatingStars newValue={overAllRating} />
                                      <HeadingDesc
                                        text={<b>{besideMannerRating}.00</b>}
                                      />
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                              <div className="totalReviews">
                                <HeadingDescSmall
                                  text={<b>{totalRevies} Reviews</b>}
                                />
                              </div>
                              <DoctorReviewCard data={reviews} />
                              <hr />
                            </section>
                            <section id="faqs">
                              <div className="tabTitle">
                                <HeadingWithSpaceLarge text="FAQS" />
                              </div>
                              <AccordionComp data={faqs} />
                            </section>
                          </ScrollSpy>
                        </Col>
                      </Row>
                    </div>
                  );
                })}
              </div>
            </Col>
            <Col md={4}>
              <div className="rightBox">
                <SectionInnerHeading text="Book an Appointment" />
                <div className="inputBox">
                  <HeadingDescVsmall text="Select Type of Appointment" />
                  <CustomSelect2
                    options={typeOfAppoinment}
                    defaultValue={typeOfAppoinment[0]}
                  />
                </div>
                <div className="inputBox">
                  <HeadingDescVsmall text="Select Clinic" />
                  <CustomSelect2 options={selectClinic} placeholder="" />
                </div>
                <div className="inputBox">
                  <HeadingDescVsmall text="Reason for Consultation" />
                  <CustomSelect2
                    options={reasonForConsultation}
                    defaultValue={reasonForConsultation[0]}
                  />
                </div>
                <div className="inputBox">
                  <HeadingDescVsmall text="Select available time" />
                  <CustomCalender />
                </div>
                <SimpleAncerSmall text="CONTINUE BOOKING" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Layouts>
  );
}

export default DoctorDetail;
